
document.addEventListener('change', function (event) {
  if (event.target.matches('input[name="properties[Selected Size]"]')) {
    const container = event.target.closest('.numeric-size-picker');

    if (!container) return;

    const label = container.querySelector('#selected-size-label');

    if (label) {
      label.textContent = event.target.value;
    }
  }
});
